module.exports = __webpack_public_path__ + "img/score-icon.c80bd70.png";